/* Your Favourite Corner — v4 behaviour
   Loaded after app.js. Adds only what the v4 sections need: the promo
   countdown and the style quiz. Everything else (cart, quick add, carousel
   arrows, reveals, header scroll) still lives in app.js. */
(function () {
  'use strict';

  /* ------------------------------------------------------------- countdown
     Renders only while the target is in the future. Once it passes, the
     clock removes itself rather than sitting at zero. */
  document.querySelectorAll('[data-countdown]').forEach(function (clock) {
    var target = Date.parse(clock.getAttribute('data-countdown'));
    if (isNaN(target)) { clock.remove(); return; }
    if (target - Date.now() <= 0) { clock.remove(); return; }

    var out = {
      days:  clock.querySelector('[data-cd="days"]'),
      hours: clock.querySelector('[data-cd="hours"]'),
      mins:  clock.querySelector('[data-cd="mins"]'),
      secs:  clock.querySelector('[data-cd="secs"]')
    };

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    var timer = null;

    function tick() {
      var left = target - Date.now();
      if (left <= 0) {
        if (timer) { clearInterval(timer); }
        clock.remove();
        return;
      }
      var s = Math.floor(left / 1000);
      if (out.days)  out.days.textContent  = pad(Math.floor(s / 86400));
      if (out.hours) out.hours.textContent = pad(Math.floor(s % 86400 / 3600));
      if (out.mins)  out.mins.textContent  = pad(Math.floor(s % 3600 / 60));
      if (out.secs)  out.secs.textContent  = pad(s % 60);
    }

    tick();
    clock.hidden = false;
    timer = setInterval(tick, 1000);
  });

  /* ------------------------------------------------------------------ quiz */
  document.querySelectorAll('[data-quiz]').forEach(function (quiz) {
    var steps = Array.prototype.slice.call(quiz.querySelectorAll('[data-quiz-step]'));
    if (steps.length < 2) { return; }

    var dots = quiz.querySelectorAll('[data-quiz-dot]');
    var go = quiz.querySelector('[data-quiz-go]');
    var base = quiz.getAttribute('data-base') || 'all';

    var index = 0;
    var answers = [];

    function show(i) {
      index = i;
      steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      for (var d = 0; d < dots.length; d++) { dots[d].classList.toggle('is-on', d <= i); }
      var focusable = steps[i].querySelector('button, a');
      if (focusable && i > 0) { focusable.focus({ preventScroll: true }); }
    }

    function buildUrl() {
      var collection = base;
      var tags = [];
      answers.forEach(function (a) {
        if (!a || !a.value) { return; }
        if (a.kind === 'collection') { collection = a.value; }
        else { tags.push(a.value); }
      });
      var url = '/collections/' + encodeURIComponent(collection);
      if (tags.length) { url += '/' + tags.map(encodeURIComponent).join('+'); }
      return url;
    }

    quiz.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-quiz-opt]');
      if (opt) {
        var step = opt.closest('[data-quiz-step]');
        answers[index] = {
          kind: step.getAttribute('data-quiz-kind') || 'tag',
          value: opt.getAttribute('data-quiz-opt') || ''
        };
        if (index + 1 < steps.length - 1) {
          show(index + 1);
        } else {
          if (go) { go.setAttribute('href', buildUrl()); }
          show(steps.length - 1);
        }
        return;
      }

      if (e.target.closest('[data-quiz-back]')) {
        show(Math.max(0, index - 1));
        return;
      }

      if (e.target.closest('[data-quiz-restart]')) {
        answers = [];
        show(0);
      }
    });
  });
})();
